<template>

    <div>
        <div v-if="mode=='query'" class="row doc-container">
            <div class="col-10 left-align">
            <p>
                <b v-if="collection_name=='plazi'">{{ getTreatmentTitle }}</b>
                <b v-else>{{ getTitle }}</b>
                {{ getId }}.
                {{ getAuthors }}
                {{ getDate }}
                {{ getJournal }}
                {{ getPublicationTypes }}
                {{ getLicence }}
                <ExternalLinks :int_links="int_sources" :ext_links="ext_sources"/>
            </p>
            </div>
            <div class="col-2 center-align">
                {{ all_passages.length }} passage<span v-if="all_passages.length > 1">s</span> in this document 
            </div>              
        </div>
        <div v-for="(passage, index) in all_passages" :key="'passage_'+index" class="row passage-container">

            <div class="info-container">
                in <b>{{ passage.field }}</b><br/>
                <!-- {{ passage.size }} sentence<span v-if="passage.size > 1">s</span> -->
            </div>

            <div class="text-container">
                <span class="text-element" v-html="highlightAll(passage)"></span>
            </div>

        </div>
        <br/>

    </div>

</template>


<script>
import { mapState } from 'vuex'
import ExternalLinks from '@/components/ExternalLinks.vue'

export default {
  name: 'ResultsPassage',
  components: {
    ExternalLinks
  },
  props: {
    mode: {
        type: String,
        required: true,
    },
    document: {
        type: Object,
        required: true,
    },
    collection_name: {
        type: String,
        required: true
    },
  },
  data() {
    return {
        in_progress: true,
        documents: [],
    };
  },
  computed: {
    ...mapState(['user_query', 'theme_color', 'urls']),
    cssVars () {
        return{
            '--color': this.theme_color.main,
        }
    },
    int_sources(){
        var encoded_id = encodeURIComponent(this.document.doc_id)
        var sources = []
        if (this.collection_name == "plazi"){
            var linkpla = {}
            linkpla.name = "TreatmentBank"
            linkpla.url = "http://treatment.plazi.org/id/"+this.document.doc_id
            sources.push(linkpla)
        }
        var linksibils = {}
        linksibils.name = "BiodiversityPMC"
        linksibils.url = "https://biodiversitypmc.sibils.org/collections/"+this.collection_name+"/"+encoded_id
        sources.push(linksibils)
        var linkbiotic = {}
        var url = this.urls.gui
        if (process.env.NODE_ENV != 'production'){
            url = window.location.origin
        }
        linkbiotic.name = "BiotXplorer"
        linkbiotic.url = url+"/collections/"+this.collection_name+"/"+encoded_id
        sources.push(linkbiotic)
        return sources
    },
    ext_sources(){
        var sources = []
        if (this.collection_name == "medline"){
            var linkmed = {}
            linkmed.name = "MEDLINE"
            linkmed.url = "https://pubmed.ncbi.nlm.nih.gov/"+this.document.doc_id
            sources.push(linkmed)
        }
        return sources
    },
    all_passages() {
        if (this.document){
            return this.document.passages
        }
        else {
            return this.passages
        }
    },
    document_name(){
        if (this.collection_name == "medline"){
            return "PMID"
        }
        else if (this.collection_name == "pmc"){
            return ""
        }
        else if (this.collection_name == "plazi"){
            return "Treatment "
        }
        else if (this.collection_name == "plazi"){
            return "Supplementary material "
        }
        return "Document "
    },
    doc_info(){
        return this.document.document
    },
    getId(){
            if ("_id" in this.doc_info){
                return this.doc_info._id
            }
            else{
                return ""
            }
        },
        getTitle(){
            if ("title" in this.doc_info){
                return this.doc_info.title
            }
            else{
                return ""
            }
        },
        getTreatmentTitle(){
            if ("treatment_title" in this.doc_info){
                return this.doc_info.treatment_title+". "+this.doc_info['article-title']
            }
            else{
                return ""
            }
        },
        getAuthors() {
            if ('authors' in this.doc_info) {
                var authors = []
                if (Array.isArray(this.doc_info.authors)){
                    authors = this.doc_info.authors
                }
                else {
                    authors = this.doc_info.authors.split("|")
                }
                if (authors.length <= 7){
                    return authors.join(', ')+". "
                }
                else {
                    return authors.slice(0, 5).join(', ')+ ", et al. "
                }
            }
            else{
                return ""
            }
        },
        getDate() {
            if ('entrez_date' in this.doc_info && this.doc_info.entrez_date != null) {
                return this.doc_info.entrez_date+". "
            }
            else if ('pmc_release_date' in this.doc_info && this.doc_info.pmc_release_date != null)  {
                if ('publication_date' in this.doc_info && this.doc_info.publication_date != this.doc_info.pmc_release_date){
                    return this.doc_info.publication_date +" (released: "+this.doc_info.pmc_release_date+"). "
                }
                else {
                    return this.doc_info.pmc_release_date+". "
                }
            }
            else if ('publication_date' in this.doc_info && this.doc_info.publication_date != null) {
                return this.doc_info.publication_date+". "
            }
            else if ('pubyear' in this.doc_info && this.doc_info.pubyear != null) {
                return this.doc_info.pubyear+". "
            }
            return ""
        },
        getJournal() {
            if ('journal' in this.doc_info) {
                return this.doc_info.journal+". "
            }
            else{
                return ""
            }
        },
        getLicence(){
            if (this.doc_info && 'licence' in this.doc_info && this.doc_info.licence != null) {
                return "Licence "+this.doc_info.licence+". "
            }
            else{
                return ""
            }
        },
        getPublicationTypes() {
            if ('publication_types' in this.doc_info) {
                if (Array.isArray(this.doc_info.publication_types)){
                    return this.doc_info.publication_types.join(",")+". "
                }
                else {
                    return this.doc_info.publication_types.replaceAll('|', ', ')+". "
                }
            }
            else{
                return ""
            }
        },
  },
  methods:{
    highlightAll(passage) {
    let colors = ["red", "blue", "green"];
    let terms = [];

    // Construire la liste des mots avec leur couleur
    passage.highlight.forEach((words, index) => {
        words.forEach(word => {
            terms.push({ word, color: colors[index] });
        });
    });

    // Trier les termes par longueur décroissante
    terms.sort((a, b) => b.word.length - a.word.length);

    let highlighted_inputText = passage.text;

    terms.forEach(({ word, color }) => {
        let escapedWord = word.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); // Échapper les caractères spéciaux
        let re = new RegExp("(" + escapedWord + ")", "gi");

        // Remplacer uniquement si ce n'est pas déjà dans un <span>
        highlighted_inputText = highlighted_inputText.replace(re, (match, p1, offset, string) => {
            // Vérifier si le match est dans une balise <span>
            let before = string.slice(0, offset);
            let insideTag = before.lastIndexOf("<span") > before.lastIndexOf("</span>");

            return insideTag ? match : `<span style="color:${color}">${match}</span>`;
        });
    });

    return highlighted_inputText.replaceAll("\n", "<br/>");
}


  },

}

</script>


<style scoped lang="scss">

.doc-container {
    text-align: center;
    padding: 10px 0;
    width: 100%;
    background-color: #ddd;
    margin: 0
}

.left-align {
    text-align: left;
    padding-left: 20px;
}
.right-align {
    text-align: right;
    padding-right: 160px;
}
.center-align {
    text-align: center
}

.progress-container {
    text-align: center;
}

.passages-container {
    text-align: left;
    padding: 10px 0 20px 0;
    margin: 0;
    width: 100%;
}

.passage-container {
    text-align: justify;
    margin: 10px 0 10px 0;
    display: flex;
    width: 100%;
    border: 2px solid #eee;
    border-radius: 10px;

}

.info-container {
    text-align: center;
    background-color: #eee;
    color: #000;
    padding: 20px 10px;
    border-radius: 10px;
    width: 15%;
}

.text-container {
    color: #000;
    width: 85%;
    display: table;
    table-layout: fixed;
    word-wrap: break-word;
    border-collapse: separate;
    border-spacing: 10px;
}



label {
    padding-top: 5px;
    font-weight: bold;
}

a{
    margin-left: 10px;
}

.right-label {
    text-align: right;
    width: 100%;
    background-color: pink;
}


</style>
